import css from "./Services.module.css";

const Service = ({ children, isPremium }) => {
  return (
    <li className={css.service}>
      <div className={css.icon_container}>
        <img
          className="icon_small"
          alt={isPremium ? "plus" : "check"}
          src={
            isPremium
              ? require("../../images/premium.png")
              : require("../../images/check.png")
          }
        />
      </div>
      <div className={css.children}>{children}</div>
    </li>
  );
};

export default Service;
